import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { SortDirection } from './tableTypes';

/**
 * Utility function to merge Tailwind classes
 */
const cn = (...inputs: (string | undefined | null | false)[]) => twMerge(clsx(inputs));

/**
 * Sort indicator icon
 */
export const SortIcon = ({ direction }: { direction: SortDirection }) => (
  <span className="ml-1 inline-flex flex-col">
    <svg
      className={cn('w-2 h-2 -mb-0.5', direction === 'asc' ? 'text-primary' : 'text-surface-500')}
      viewBox="0 0 8 4"
      fill="currentColor"
    >
      <path d="M4 0L8 4H0L4 0Z" />
    </svg>
    <svg
      className={cn('w-2 h-2 -mt-0.5', direction === 'desc' ? 'text-primary' : 'text-surface-500')}
      viewBox="0 0 8 4"
      fill="currentColor"
    >
      <path d="M4 4L0 0H8L4 4Z" />
    </svg>
  </span>
);
